import React, { useState } from "react";
import "./style.css";
import { useNavigate } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';


const ForgotPassword = () => {
    const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [errorDisplay, setErrorDisplay] = useState(false);
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
  const onClickNavigate = (page: string) => {
    navigate(`${page}`);
  };

  const CloseError = () => {
    setErrorDisplay(false);
  }

  const onClick = () => {
    let hasError = true;

    if (email === "") {
      
      hasError = false;
      setErrorDisplay(true);
    } else if (!emailRegex.test(email)) {
      hasError = false;
      setErrorDisplay(true);

    }else{
      setErrorDisplay(false);
    }
    if(hasError === true){
    }
  };

  return (
    <div className="loginMainDiv">
      <div className="loginDiv-forgotPass">
        <div>
          <h2 className="loginText">Forgot Password</h2>
          <div>
            <div className="mb-3 inputFieldDivLogin">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label inputLoginLabel"
              >
                EMAIL
              </label>
              <input
                className="form-control input-style-forgotpass inputBorderNone"
                placeholder="Email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <a
                  className="forgotPasswordDiv"
                  onClick={() => onClickNavigate("/resetpassword")}
                  href="/"
                >
                  Reset Password?
                </a>
            </div>
            <div className="submitBtnDiv">
              <button
                type="submit"
                className="btn btn-primary submitBtnForgotpassword"
                onClick={onClick}
              >
                Forgot Password
              </button>
            </div>
            {errorDisplay === true && (
              <div className="forgotPasswordMainDiv">
                <div className="error-style-Login">
                  Invalid email 
                </div>
                <div className="error-style-Login-btn" onClick={CloseError}><CloseIcon style={{fontSize: '0.8rem'}} /></div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
